import { cn } from "@loot-os/ui/lib/utils";
import type { ReactNode } from "react";

/** A Retool-style tag pill: a small coloured label whose colour comes from `className`. */
export function OrderTag({ className, children }: { className: string; children: ReactNode }) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded px-1.5 py-0.5 text-xs font-medium whitespace-nowrap",
        className,
      )}
    >
      {children}
    </span>
  );
}
